import React, { Component } from "react"

import withApolloClient from '../withApolloClient'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import "./PrimaryListingContainer.css"

class PrimaryListingContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isReloading: false,  // New state to track reload vs load more
            columnWidths: [],
            columnCount: 5,
        }
        this.tableRef = React.createRef()
    }

    componentDidMount() {
        this.updateColumnWidths()
    }

    componentDidUpdate(prevProps) {
        // Update column widths when children change
        if (prevProps.children !== this.props.children) {
            this.updateColumnWidths()
        }
    }

    updateColumnWidths = () => {
        if (this.tableRef.current) {
            let headerRow = this.tableRef.current.querySelector('thead tr')
            if (headerRow && headerRow.cells) {
                let cells = headerRow.cells
                // Get percentage widths instead of fixed pixel widths
                let totalWidth = headerRow.offsetWidth
                let widths = Array.from(cells).map(cell => `${(cell.offsetWidth / totalWidth) * 100}%`)
                this.setState({
                    columnWidths: widths,
                    columnCount: cells.length
                })
            }
        }
    }

    loadMoreEntries = () => {
        this.setState({ isLoading: true }, () => {
            this.props.loadMoreEntries().then(() => {
                this.setState({ isLoading: false })
            })
        })
    }

    fetchMoreEntries = () => {
        this.setState({ isReloading: true }, () => {
            this.props.refetchListQuery().then(() => {
                this.setState({ isReloading: false })
            })
        })
    }

    renderSkeletonRows = () => {
        return [...Array(15)].map((_, rowIndex) => (
            <tr key={`skeleton-${rowIndex}`} className="skeleton-row">
                {[...Array(this.state.columnCount)].map((_, colIndex) => (
                    <td key={colIndex} style={{ width: this.state.columnWidths[colIndex] }}>
                        <Skeleton height={20} />
                    </td>
                ))}
            </tr>
        ))
    }

    render() {
        // Clone the children (table) and append or replace with skeleton rows
        const childrenWithSkeletons = React.Children.map(this.props.children, child => {
            if (!child) return child

            return React.cloneElement(child, {
                children: React.Children.map(child.props.children, tableChild => {
                    if (tableChild?.type === 'tbody' || tableChild?.type?.displayName === 'Tbody') {
                        return React.cloneElement(tableChild, {
                            children: <>
                                {(!this.state.isReloading && !this.props.listLoading) && tableChild.props.children}
                                {(this.props.listLoading || this.state.isLoading || this.state.isReloading) && (
                                    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
                                        {this.renderSkeletonRows()}
                                    </SkeletonTheme>
                                )}
                            </>
                        })
                    }
                    return tableChild
                })
            })
        })

        return (
            <div className="vgm-primary-listing-container">
                <div className="vgm-primary-listing-container__body">
                    <div ref={this.tableRef}>
                        {childrenWithSkeletons}
                    </div>
                </div>
                {(!this.props.listLoading && !this.state.isLoading && !this.state.isReloading) &&
                    <div className="vgm-primary-listing-container__footer">
                        {this.props.refetchListQuery &&
                            <a className="float-left" onClick={this.fetchMoreEntries}>
                                <i className="fa fa-refresh"></i>&nbsp;&nbsp;RELOAD
                            </a>
                        }
                        {this.props.pageInfo && this.props.pageInfo.length ?
                            <span className="float-center">
                                Showing {this.props.totalFetchedRows} out of {this.props.pageInfo.length} {this.props.pageInfo.length > 1 ? "entries" : "entry"}.
                            </span>
                            : ""}
                        {this.props.loadMoreEntries &&
                            <a className="float-right" onClick={this.loadMoreEntries}>
                                <i className="fa fa-angle-double-down"></i>&nbsp;&nbsp;LOAD MORE
                            </a>
                        }
                    </div>
                }
            </div>
        )
    }
}

export default withApolloClient(PrimaryListingContainer)